/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Final verdict assigned to the detection
 * @export
 */
export const ControlVerdict4 = {
    Malicious: 'MALICIOUS',
    Suspicious: 'SUSPICIOUS',
    Benign: 'BENIGN'
} as const;
export type ControlVerdict4 = typeof ControlVerdict4[keyof typeof ControlVerdict4];


export function ControlVerdict4FromJSON(json: any): ControlVerdict4 {
    return ControlVerdict4FromJSONTyped(json, false);
}

export function ControlVerdict4FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlVerdict4 {
    return json as ControlVerdict4;
}

export function ControlVerdict4ToJSON(value?: ControlVerdict4 | null): any {
    return value as any;
}

